import { curry, equals, findIndex, move } from 'ramda';
import { Operator } from '../api/generated';
import { duplicityStyle, rootStyle, selectedStyle } from './styles';
const _calculateNextIndex = (movedIndex, targetIndex) => {
    if (targetIndex === 0)
        return 0;
    if (targetIndex < movedIndex)
        return targetIndex + 1;
    return targetIndex;
};
export const reorderByFieldName = curry((fromFieldName, toFieldName, list) => {
    const fromIndex = findIndex(equals(fromFieldName), list);
    const toIndex = findIndex(equals(toFieldName), list);
    const nextIndex = _calculateNextIndex(fromIndex, toIndex);
    if (fromIndex < 0 || toIndex < 0)
        return list;
    return move(fromIndex, nextIndex, list);
});
export const hasDuplicityFilter = (filterCondition) => filterCondition?.andConditions?.some((andCondition) => andCondition.orConditions?.some((orCondition) => orCondition.operator === Operator.Duplicity)) ?? false;
export const getRowStyle = (row, isSelected) => {
    if (isSelected) {
        return selectedStyle;
    }
    if (row.isDuplicityOriginal === false) {
        return duplicityStyle;
    }
    return rootStyle;
};
//# sourceMappingURL=helpers.js.map